
<template>
  <div>
    <label class="text-sm opacity-75">
      {{ $te('filters.' + filter.title + '.title')?$t('filters.' + filter.title + '.title'):filter.title }}
    </label>

    <vs-select v-model="selected"
              autocomplete
              color="success"
              class="w-full">
      <vs-select-item :value="null" :text="''"></vs-select-item>
      <template v-for="group in groups">
        <template v-if="isSingleGroup">
          <vs-select-item v-for="term in group" :key="term.value"
                          :value="term.value"
                          :text="term.translate ? $t('filters.' + filter.title + '.values.' + term.label) : term.label"
                          :class="{'text-primary':isSelected(term)}"></vs-select-item>
        </template>
        <template v-else>
          <div :key="group.groupName">
            <vs-select-group :title="group.groupName">
              <vs-select-item v-for="term in group" :key="term.value"
                              :value="term.value"
                              :text="term.translate ? $t('filters.' + filter.title + '.values.' + term.label) : term.label"
                              :class="{'text-primary':isSelected(term)}"></vs-select-item>
            </vs-select-group>
          </div>
        </template>
      </template>
    </vs-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'sm-hateoas-filter-terms-select',
  components: {
    vSelect
  },
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          terms: []
        };
      }
    }
  },
  data () {
    return {
      selected: this.filter.terms.filter(t => t.selected).map(t => t.value)
    };
  },
  computed: {
    groups () {
      return Object.groupBy(this.filter.terms, ({group}) => group || '');
    },
    isSingleGroup () {
      return Object.keys(this.groups).length === 1;
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    isSelected (term) {
      return this.selected.indexOf(term.value) >= 0;
    }
  }
};
</script>

<style scoped>

</style>
